import { Box, BoxProps, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { theme } from '@store';

interface IHttpErrorMessageProps extends BoxProps {
  message: string;
}

export const HttpErrorMessage = ({
  message,
  ...props
}: IHttpErrorMessageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        bgcolor: theme.palette.red.main,
        px: '1rem',
        py: '0.75rem',
        gap: '0.75rem',
        width: '100%',
      }}
      {...props}
    >
      <ErrorIcon htmlColor={theme.palette.common.white} />
      <Typography
        variant='body2'
        sx={{ fontWeight: 500, fontSize: '14px', color: 'white' }}
      >
        {message}
      </Typography>
    </Box>
  );
};
